import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {Config} from '../../../config/config';
import {TransferStateService} from './transfer-state.service';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private apiService: ApiService, private transferState: TransferStateService) {
  }

  public getGallery(code): Observable<HttpResponse<any>> {
    return this.transferState.runApi(
      `gallery-gallery-${code}`,
      this.apiService.translateApi((l) => this.apiService.get(Config.ENDPOINTS.galleries.gallery(code), undefined, undefined, l))
    );
  }
}
